function decode(token: string): any {
  const contents = token.split('.')[1];
  return contents ? JSON.parse(window.atob(contents)) : {};
}

export default {
  decode,
};
